module.exports = "../images/fishing-lure-2.png?v=83c4b0b";